import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Добавить партию")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Добавить продукт")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Выход")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_space = _resolveComponent("el-space")!

  return (_openBlock(), _createBlock(_component_el_space, { size: "large" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_button, {
        size: "small",
        round: "",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/lot/add')))
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        size: "small",
        round: "",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/product/add')))
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        size: "small",
        round: "",
        onClick: _ctx.logout
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  }))
}